// top level button to toggle showing dropdown
import React from 'react';
import PropTypes from 'prop-types';

import './styles/search_dropdown.scss';

/* Props:
  title: Text to display within button
*/
const DropdownToggleButton = ({ title = '' }) => (
  <button className="search-dropdown__toggle" tabIndex="0" data-testid="search-dropdown-toggle">
    <span className="search-dropdown__title">{t(title)}</span>
    <span className="bff-dropdown-carrot" />
  </button>
);

DropdownToggleButton.propTypes = {
  title: PropTypes.string.isRequired
};

export default DropdownToggleButton;
